<template>
<div class="shareConfig-ui">
    <div class="swiper-box-bg">
        <div class="swiper-container swiper-box" :class="{'filter':scrollTop>height}">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,i) in datas.backgroundImgList" :key="i">
                    <div class="imgBg" :style="imgBgs[i]"></div>
                </div>
            </div>
        </div>
        <div class="swiper-box-text" :class="{'filter-item':scrollTop>height}" v-if="datas.backgroundImgList&&datas.backgroundImgList.length>0">
            <div class="text" v-if="datas.backgroundImgList[swiperCurrent]">
                {{datas.backgroundImgList[swiperCurrent].imgText}}
            </div>
        </div>
        <div class="weather" :style="weatherStyle" v-if="weather.type" :class="{'filter-item':scrollTop>height}">
            <img class="weather_icon" :src="weather.icon">
            <div class="weather_info">
                <div class="weather_info_lf">
                    <div class="today">今天</div>
                    <div class="weather_temperature">{{weather.low}}-{{weather.high}}℃</div>
                </div>
                <div class="weather_name">
                    {{weather.type}}
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
// 标题
import moment from 'moment'
import {
    setStorage,
    getStorage
} from "@/utils/wxuser";
import api from "@/utils/api";
import {
    jAlert3
} from "@/base/jAlert/jAlert";
import Swiper from "swiper";
export default {
    data() {
        return {
            weather: {},
            scrollTop: 0,
            weatherList: [{
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/大到暴雪.png',
                    name: "大到暴雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/大到暴雨.png',
                    name: "大到暴雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/大雪.png',
                    name: "大雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/大雨.png',
                    name: "大雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/多云.png',
                    name: "多云"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/雷阵雨.png',
                    name: "雷阵雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/霾.png',
                    name: "霾"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/晴.png',
                    name: "晴"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/雾.png',
                    name: "雾"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/小到中雪.png',
                    name: "小到中雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/小到中雨.png',
                    name: "小到中雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/小雪.png',
                    name: "小雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/雨夹雪.png',
                    name: "雨夹雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/预警.png',
                    name: "预警"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/阴.png',
                    name: "阴"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/阵雨.png',
                    name: "阵雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/中到大雪.png',
                    name: "中到大雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/中到大雨.png',
                    name: "中到大雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/中雪.png',
                    name: "中雪"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/中雨.png',
                    name: "中雨"
                },
                {
                    icon: 'https://xcx.ihotel.cn/mall/images/weather/小雨.png',
                    name: "小雨"
                },
            ],
            swiperCurrent: 0,
            height: 0,
            swiper: null
        }
    },
    props: {
        datas: Object
    },

    methods: {
        initSwiper() {
            var _this = this
            if (this.datas.backgroundImgList.length > 1) {
                var len = this.datas.backgroundImgList.length
                this.swiper = new Swiper(".swiper-container", {
                    autoplay: true,
                    paginationClickable: true,
                    autoplayDisableOnInteraction: true, // 处理手动滑动后，继续自动滑动
                    loop: true,
                    observer: true,
                    observeParents: true,
                    on: {
                        slideChange: function () {
                            _this.swiperCurrent = (this.activeIndex - 1) % len

                        },

                    }

                });
            }

        },
        swiperChange(e) {
            console.log(e)
            this.swiperCurrent = e.target.current

        },
        getScrollTop() {
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            if (this.scrollTop > this.height) {
                this.swiper.autoplay.stop();
            } else {
                this.swiper.autoplay.start();
            }
        },
        getWetherList() {
            api.getWetherList({
                cityName: this.datas.weatherCity
            }).then(res => {
                if (res.result == 1) {
                    if (res.retVal.length > 0) {
                        this.weather = res.retVal[0]
                        this.weather.average = Math.round((this.weather.high + this.weather.low) / 2)
                        this.weatherList.forEach(item => {

                            if (item.name == this.weather.type) {
                                this.weather.icon = item.icon
                            }
                        })
                        if (!this.weather.icon) {
                            this.weatherList.forEach(item => {
                                if (item.name == '预警') {
                                    this.weather.icon = item.icon
                                }
                            })

                        }
                    }

                } else {
                    jAlert3(res.msg)
                }
            })
        },

    },
    computed: {
        weatherStyle() {
            var style = ""
            if (this.datas.showWeather) {

                style = `top:${this.datas.weatherTop/37.5}rem;right:${this.datas.weatherRight/37.5}rem;`
            }
            return style
        },
        imgBgs() {
            var imgBgs = []
            if (this.datas.backgroundImgList && this.datas.backgroundImgList.length > 0) {
                this.datas.backgroundImgList.forEach(item => {
                    var imgbg = `background: url(${item.imgUrl}) 0 0;background-size: 100%;`
                    imgBgs.push(imgbg)

                })

            }

            return imgBgs
        }

    },
    destroyed() {
        window.removeEventListener("scroll", this.getScrollTop);
    },
    mounted() {
        if (this.datas.showWeather) {
            this.getWetherList()

        }
        if (this.datas.backgroundImgList && this.datas.backgroundImgList.length > 0) {
            this.$nextTick(() => {
                this.initSwiper()
            })
        }

        this.height = 100
        window.addEventListener("scroll", this.getScrollTop);
    }
}
</script>

<style lang="less" scoped>
@import url("~@/styles/mixin.less");



.shareConfig-ui {

    .swiper-box-bg {
        position: relative;
        height: 9.7309rem;
        width: 100%;

        .filter-item {
           
            width: 120%;
            height: 120%;
            position: absolute;
            left: -10%;
            top: -10%;
            filter: blur(25px);
            background: inherit;
            z-index: 2;
        }

        .filter {
            .imgBg {
                &::after {
                    content: "";
                    width: 120%;
                    height: 120%;
                    position: absolute;
                    left: -10%;
                    top: -10%;
                    filter: blur(25px);
                    background: inherit;
                    z-index: 2;
                }
            }

        }

        .swiper-box {
            position: fixed;
            z-index: 0;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
        }

    }

    .swiper-box-text {
        position: fixed;
        top: 8.4rem;
        left: 0.5332rem;
        font-family: 'heavy';
        font-size: 25px;
        color: #FFFFFF;
        text-shadow: 0 5px 10px rgba(0, 0, 0, 0.20);
        font-weight: 600;

    }

    .imgBg {
        width: 100%;
        height: 100vh;
        background-size: cover;
        background-position-x: center;

    }

    .weather {
        display: flex;
        align-items: center;
        background: #FFFFFF;
        border-radius: 16px;
        position: fixed;
        top: -1.8662rem;
        right: 0.5332rem;
        padding: 0.1333rem 0.2666rem;

        .weather_icon {
            height: 0.42656rem;

        }

        .weather_info {
            line-height: 1.4;
            margin-left: 0.1333rem;
            font-size: 8px;
            color: @color-theme;

            .weather_info_lf {
                padding-top: 1px;
                display: inline-block;
            }

            .weather_name {
                vertical-align: top;
                display: inline-block;
                box-sizing: content-box;
                max-width: 2em;
                margin-left: 0.1333rem;
                color: @color-theme;
                padding: 0 0.05332rem;
                border: 1px solid @color-theme;
                border-radius: 2px;
                max-height: 22px;
                overflow: hidden;
                line-height: 11px;
            }
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/shareConfig.vue